/**
 * 热度计算工具
 */

import type { GameSummary } from '../api/types';

/**
 * 热度计算配置
 */
const HEAT_CONFIG = {
  /** 浏览量权重 */
  VIEW_WEIGHT: 1,
  /** 点击量权重（点击更有价值） */
  CLICK_WEIGHT: 2,
  /** 时间衰减系数（可选） */
  TIME_DECAY: 0.99,
};

/**
 * 计算游戏热度分数（兼容旧版接口）
 * @param viewCount 浏览量
 * @param clickCount 点击量
 * @returns 热度分数
 */
export function calculateHeat(viewCount: number, clickCount: number = 0): number {
  const viewScore = viewCount * HEAT_CONFIG.VIEW_WEIGHT;
  const clickScore = clickCount * HEAT_CONFIG.CLICK_WEIGHT;
  return viewScore + clickScore;
}

/**
 * 计算游戏热度分数
 * @param game 游戏数据
 * @returns 热度分数
 */
export function calculateHeatScore(game: GameSummary & { clickCount?: number }): number {
  return calculateHeat(game.viewCount, (game as any).clickCount || 0);
}

/**
 * 格式化热度显示
 * 超过1000显示为k，超过10000显示为w
 */
export function formatHeatScore(score: number): string {
  if (score >= 10000) {
    return `${(score / 10000).toFixed(1)}w`;
  }
  if (score >= 1000) {
    return `${(score / 1000).toFixed(1)}k`;
  }
  return String(score);
}

/**
 * 按热度排序游戏列表
 */
export function sortByHeat(games: GameSummary[]): GameSummary[] {
  return [...games].sort((a, b) => calculateHeatScore(b) - calculateHeatScore(a));
}

/**
 * 获取热度等级（用于显示火焰图标数量）
 * @param score 热度分数
 * @returns 1-5的等级
 */
export function getHeatLevel(score: number): number {
  if (score >= 50000) return 5;
  if (score >= 30000) return 4;
  if (score >= 15000) return 3;
  if (score >= 5000) return 2;
  return 1;
}
